module.exports = __webpack_public_path__ + "img/iphone-aoty-2018_en.8d02581.svg";